/** Prioridade dos Negócios */
export interface NegocioPrioridade {
    id: number;
    nome: string;
    cor: string;
}

export const prioridadeBaixa: NegocioPrioridade = {
    id: 1,
    nome: 'Baixa',
    cor: '#acacac'
};
export const prioridadeMedia: NegocioPrioridade = {
    id: 2,
    nome: 'Média',
    cor: '#fcb102'
};
export const prioridadeAlta: NegocioPrioridade = {
    id: 3,
    nome: 'Alta',
    cor: '#e2313c'
};


export const prioridades: NegocioPrioridade[] = [
    prioridadeBaixa,
    prioridadeMedia,
    prioridadeAlta
];


/** Verifica se a prioridade do negócio é baixa */
export function isPrioridadeBaixa(prioridade: number): boolean {
    if (!prioridade) {
        return false;
    }
    return prioridade === prioridadeBaixa.id;
}

/** Verifica se a prioridade do negócio é média */
export function isPrioridadeMedia(prioridade: number): boolean {
    if (!prioridade) {
        return false;
    }
    return prioridade === prioridadeMedia.id;
}

/** Verifica se a prioridade do negócio é alta */
export function isPrioridadeAlta(prioridade: number): boolean {
    if (!prioridade) {
        return false;
    }
    return prioridade === prioridadeAlta.id;
}
